import * as yup from 'yup';

export const customerExcelSchema = yup.object().shape({
    customercode: yup
        .string()
        .required('Cari Hesap Kodu zorunludur')
        .max(50, 'Cari Hesap Kodu 50 karakterden uzun olamaz'),
    customername: yup
        .string()
        .required('Cari Hesap Ünvanı zorunludur')
        .max(150, 'Cari Hesap Ünvanı 150 karakterden uzun olamaz'),
    phone: yup
        .string()
        .required('Telefon numarası zorunludur')
        .matches(
            /^(\d{10}|[.\(\/]?5[0-9]{2}[.\)\/]?[.\ \/][0-9][0-9]{2}[.\ \/]?[0-9]{2}[.\ \/]?[0-9]{2})$/,
            "Lütfen telefon numarasını doğru formatta giriniz; 5xx xxx xx xx"
        ),
    email: yup
        .string()
        .required('Lütfen E-Posta adresini giriniz')
        .email('Lütfen E-Posta adresini doğru formatta giriniz'),
    taxcode: yup
        .string()
        .max(10, 'VKN en fazla 10 haneli olabilir.')
        .min(10, 'VKN en az 10 haneli olabilir.'),
    taxoffice: yup.string()
        .max(150, 'Vergi Dairesi 150 karakterden uzun olamaz'),
    tccode: yup
        .string()
        .max(11, 'TCKN en fazla 11 haneli olabilir.')
        .min(11, 'TCKN en az 11 haneli olabilir.'),
});